import { useMemo, useRef } from 'react';
export function useDebounceCallback() {
  const timeout = useRef(null);
  return useMemo(() => [(callback, ms) => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => {
      void callback();
      timeout.current = null;
    }, ms);
  }, () => {
    if (timeout.current) {
      clearTimeout(timeout.current);
      timeout.current = null;
    }
  }, timeout], []);
}